import { render, staticRenderFns } from "./TransfiyaBancaria.vue?vue&type=template&id=9ed55fb4&scoped=true"
import script from "./TransfiyaBancaria.vue?vue&type=script&lang=js"
export * from "./TransfiyaBancaria.vue?vue&type=script&lang=js"
import style0 from "./TransfiyaBancaria.vue?vue&type=style&index=0&id=9ed55fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed55fb4",
  null
  
)

export default component.exports